import { urlHttpGov } from "../../urls";
import httpClient from "../httpClient";
class PanelUserAccessRecovery {
    private baseURL = `${urlHttpGov}/panel/access/recovery`;

    async sendEmailResetPassword(email: string): Promise<{msg: string}>  {
        const response = await httpClient.get(`${this.baseURL}/${email}`);

        return response.data;
    }

    async resetPassword({code, password} : {code: string, password: string}): Promise<{msg: string}>  {
        const response = await httpClient.post(`${this.baseURL}`, {code, password});

        return response.data;
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PanelUserAccessRecovery();